import CreateTaskScreen from '../../src/screens/CreateTaskScreen';

export default function CreateTaskRoute() {
  return <CreateTaskScreen />;
}
